/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Online_Price_SearchInputs */

const vi_online_price_search = /** @type {(inputs: Online_Price_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm theo mã SKU hoặc tên sản phẩm`)
};

/**

* @param {Online_Price_SearchInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const online_price_search = /** @type {((inputs?: Online_Price_SearchInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Online_Price_SearchInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_online_price_search(inputs)
});